var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.965,
    height: 24.208,
    viewBox: "0 0 26 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-i-chrtp{fill:#232323;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-612.821 -296.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-chrtp",
    d: "M648.99,308.311H637.751V296.28A13.251,13.251,0,0,1,648.99,308.311Z",
    transform: "translate(-11.856 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-chrtp",
    d: "M652.468,323.57a14.746,14.746,0,0,1-3.042,7.882l-1.175-1.185-1.542-1.547-5.118-5.15Z",
    transform: "translate(-13.682 -12.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-chrtp",
    d: "M631.475,319.337a11.021,11.021,0,0,1-5.58,2.785,10.594,10.594,0,0,1-1.967.178,11.1,11.1,0,0,1-11.039-9.9,10.222,10.222,0,0,1-.068-1.206,10.475,10.475,0,0,1,.052-1.075,11.055,11.055,0,0,1,2.953-6.524,10.748,10.748,0,0,1,1.8-1.542,11,11,0,0,1,6.3-1.967v11.658l.656.656,1.311,1.322Z",
    transform: "translate(0 -1.812)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/chart-pie.33a40b6a.svg";
export { ForwardRef as ReactComponent };